import React from 'react';
import PropTypes from 'prop-types';

class Modal extends React.Component {

  static Header = ({ children, onCancel }) => (
    <div className="modal-header">
      {children}
      {onCancel ? (
        <button id="x-button" type="button" className="close" aria-label="Close" onClick={onCancel}>
          <span>&times;</span>
        </button>
      ) : null}

    </div>
  )

  static Body = ({ children }) => (<div className="modal-body">{children}</div>)

  static Footer = ({ children }) => (<div className="modal-footer">{children}</div>)

  render() {
    return (
      <div className="modal-backdrop">
        <div className="modal d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired,
};
export default Modal;
